import { ICreateEventsParams, IEvent, IEventType, IJob, IRecruiter } from './types';
import RecruitApiClient from '../RecruitApiClient';
import { IEmailTemplate } from '../NewUI/Job/types';
import { ISmsTemplate } from '../NewUI/Job/Applications/Modals/SMSCandidates';

const BASE_URL = '/api/v4';

class Api {
  getEventOptions = () =>
    RecruitApiClient.get<{ event_types: IEventType[] }>(`${BASE_URL}/calendar/event_types`);

  getEventRecruiters = () =>
    RecruitApiClient.get<{ users: IRecruiter[] }>(`${BASE_URL}/calendar/users`);

  getEvents = (date: Date, typeId?: number) =>
    RecruitApiClient.get<{ events: IEvent[] }>(`${BASE_URL}/calendar/events`, {
      date: date,
      event_type_id: typeId || undefined
    });

  deleteEvent = (id: number) => RecruitApiClient.delete(`${BASE_URL}/calendar/events/${id}`);

  createEventsBatches = (params: ICreateEventsParams) =>
    RecruitApiClient.post<{ events: IEvent[] }>(`${BASE_URL}/calendar/event_batches`, {
      event_batch: params
    });

  removeAttendees = (eventId: number, params: number[]) =>
    RecruitApiClient.post(`${BASE_URL}/calendar/events/${eventId}/remove_attendees`, {
      attendee_ids: params
    });

  updateEvent = (id: number, params: ICreateEventsParams) =>
    RecruitApiClient.put<IEvent>(`${BASE_URL}/calendar/events/${id}`, params);

  updateAttendeeInvitation = (eventId: number, attendeeId: number, state: string) =>
    RecruitApiClient.put<IEvent>(`${BASE_URL}/calendar/events/${eventId}/attendees/${attendeeId}`, {
      attendee: { state: state }
    });

  getEmailTemplates = () =>
    RecruitApiClient.get<{
      email_templates: Array<[string, { name: string; id: number }[]]>;
      placeholders: string;
    }>(`${BASE_URL}/email_templates?group_templates=true`);

  getEmailTemplate = (templateId: number) =>
    RecruitApiClient.get<IEmailTemplate>(`${BASE_URL}/email_templates/${templateId}`);

  getSmsTemplates = () =>
    RecruitApiClient.get<{ sms_templates: ISmsTemplate[] }>(`${BASE_URL}/sms_templates`);

  saveSmsTemplate = (smsTemplateName: string, smsMessage: string) =>
    RecruitApiClient.post<ISmsTemplate>(`${BASE_URL}/sms_templates`, {
      sms_template: {
        title: smsTemplateName,
        body: smsMessage
      }
    });

  smsCandidates = (eventId: number, applicationIds: number[], content: string) =>
    RecruitApiClient.post<{ success: number }>(`calendar/events/${eventId}/sms_candidates`, {
      applications_ids: applicationIds,
      content: content
    });

  getEventApplicationStatuses = (eventId: number) =>
    RecruitApiClient.get<{ event_application_statuses: { id: number; name: string }[] }>(
      `${BASE_URL}/calendar/events/${eventId}/event_application_statuses`
    );

  changeApplicationStatuses = (eventId: number, statusId: number, applicationIds: number[]) =>
    RecruitApiClient.post<{ success: string }>(
      `${BASE_URL}/calendar/events/${eventId}/change_status`,
      {
        application_ids: applicationIds,
        change_status: statusId
      }
    );
  sendEmailBatchesToCandidates = (eventId: number, data: Record<string, unknown>) =>
    RecruitApiClient.post(`${BASE_URL}/calendar/events/${eventId}/email_candidates`, data);

  getEventJobs = () => RecruitApiClient.get<{ jobs: IJob[] }>(`${BASE_URL}/calendar/jobs`);

  /**
   * @deprecated remove later
   */

  // inviteToTimeslot = (eventTypeId, jobId, userId, invitation: {}) =>
  //   this.post('invitations', {
  //     user_id: userId,
  //     event_type_id: eventTypeId,
  //     job_id: jobId,
  //     invitation
  //   });

  // addToEvent = (eventId, jobId, applicationId) =>
  //   this.post(`events/${eventId}/attendees`, {
  //     job_id: jobId,
  //     application_id: applicationId
  //   });

  // getJobApplications = (id: number) => this.get(`jobs/${id}/applications`);

  // getRecrutRecruitersById = (id: number) => this.custom_get(`users?event_batch_id=${id}`);

  // getEventBatchesById = (id: string) => this.get(`event_batches/${id}`);

  // getEvent = (id: string) => this.get(`events/${id}`);

  // deleteEventBatch = (id: number) => this.delete(`event_batches/${id}`);

  // updateEventsBatches = (event, id) => this.put(`event_batches/${id}`, event);

  // getApplications = (id: string, body: {}) => this.get(`event_batches/${id}/applications`, body);

  // getStatuses = (id: string) => this.get(`event_batches/${id}/statuses`);

  // getAvailabilities = () => this.get('availabilities');

  // saveAvailabilities = (availabilities) => this.put('availabilities', availabilities);

  // createInvitations = (id: string, invitation: {}) =>
  //   this.post(`event_batches/${id}/invitations`, invitation);
}

export default new Api();
